import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { ReactNode } from 'react';

import css from './Collapse.module.scss';

interface CollapseProps {
  children: ReactNode;
  className?: any;
  expanded?: boolean;
  horizontal?: boolean;
}

const variants = {
  vertical: {
    open: {
      opacity: 1,
      height: 'auto',
    },
    collapsed: {
      opacity: 0,
      height: 0,
    },
  },
  horizontal: {
    open: {
      opacity: 1,
      width: 'auto',
    },
    collapsed: {
      opacity: 0,
      width: 0,
    },
  },
};

export const Collapse = ({
  children,
  expanded,
  horizontal = false,
  className,
}: CollapseProps) => (
  <AnimatePresence initial={false}>
    {expanded && (
      <motion.section
        animate='open'
        className={classNames(css.section, className)}
        exit='collapsed'
        initial='collapsed'
        key='content'
        transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
        variants={variants[horizontal ? 'horizontal' : 'vertical']}
      >
        <motion.div
          className={classNames({
            [css.verticalContent]: !horizontal,
            [css.horizontalContent]: horizontal,
          })}
          transition={{ duration: 0.5, when: 'beforeChildren' }}
          variants={{
            collapsed: { scale: 0.9 },
            open: { scale: 1 },
          }}
        >
          {children}
        </motion.div>
      </motion.section>
    )}
  </AnimatePresence>
);
